import React, {useRef, useState} from 'react'
import styled from '@emotion/styled'
import {VisibilitySensor} from 'components/VisibilitySensor'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'

import {ReviewsBackToTopButton} from '../ReviewsBackToTopButton'

const TopOfListElement = styled.div<{isMobile: boolean}>`
  position: relative;
  width: 100%;
  height: 1px;
  top: ${({isMobile}) => (isMobile ? 0 : -16)}px;
`
export const ReviewListWrapper: React.FC<{canShowBackToTop: boolean}> = ({
  children,
  canShowBackToTop
}) => {
  const {isMobile} = useDeviceLayout()
  const [topElementIsVisible, setTopElementIsVisible] = useState(true)
  const reviewsTopElementRef = useRef<HTMLDivElement>(null)

  const onBackToTopClick = () => {
    reviewsTopElementRef.current?.scrollIntoView({behavior: 'smooth'})
  }
  return (
    <>
      <VisibilitySensor initialInView={true} onChange={setTopElementIsVisible}>
        <TopOfListElement isMobile={isMobile} ref={reviewsTopElementRef} />
      </VisibilitySensor>
      {children}
      <ReviewsBackToTopButton
        onClick={onBackToTopClick}
        enabled={!topElementIsVisible && canShowBackToTop}
      />
    </>
  )
}
